module.exports = __webpack_public_path__ + "static/media/1-CriarConta.5213ff5c.jpg";